export default __webpack_public_path__ + "static/media/icon-bag-world.960be2b3.svg";